import React from 'react';
import Grid from '@mui/material/Grid';
import LoadingDialog from '../../Loading';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import { styled } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import InspectionPosFileUpload from './PosFileUpload';
import PosFileDelete from './PosFileDelete';
import IconButton from '@mui/material/IconButton';
import ExploreIcon from '@mui/icons-material/Explore';



const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})

const PreviewImg = styled('img')({
});




export default function PosFileForm(props) {

    const openMap = () => {
        const newWindow = window.open('about:blank', '_blank');
        if (newWindow) {
            // セキュリティ対策（openerから切り離し）
            newWindow.opener = null;

            // 少し待ってから地図へ遷移
            setTimeout(() => {
                try {
                    newWindow.location.href = props.mapLink;
                } catch (e) {
                    newWindow.close();
                }
            }, 200);
        }
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={inspectionTheme}>
                <Grid >
                    <LoadingDialog load={false} />
                    <CssBaseline />
                    <Grid sx={{ pl: 0 }}>
                        <Grid container rowSpacing={{ xs: 2 }} columnSpacing={{ xs: 1 }} >
                            <Grid item xs={12} >
                                <Grid container rowSpacing={{ xs: 3 }}  >
                                    <Grid container item
                                        sx={{
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}>
                                        <Grid item >
                                            <Typography sx={{ fontSize: '18px', mt: 1.5 }}>表札・外観画像</Typography>
                                        </Grid>
                                        {!props?.posStatus
                                            ? <Grid item  >
                                                <InspectionPosFileUpload
                                                    keyData={props?.keyData}
                                                    setPosStatus={props?.setPosStatus}
                                                />
                                            </Grid>
                                            :
                                            <Grid item  >
                                                <PosFileDelete
                                                    keyData={props?.keyData}
                                                    setPosStatus={props?.setPosStatus}
                                                    PDFTitle={props?.PDFTitle}
                                                    posData={props?.posData}
                                                    setMapLink={props?.setMapLink}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid container item>
                                        <Grid container item xs={12}
                                            sx={{
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {
                                                props.posData?.placeInfoFileData64 ?
                                                    <PreviewImg
                                                        src={"data:application;base64," + props.posData?.placeInfoFileData64}
                                                        alt=''
                                                        sx={{ height: '100%', width: '100%' }} />
                                                    :
                                                    <Grid sx={{ height: 100, width: '100%', backgroundColor: '#C0C0C0' }} />
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Grid container rowSpacing={{ xs: 1 }} columnSpacing={{ xs: 1 }} >
                                            <Grid item xs={2} >
                                                <Typography sx={{ fontSize: '18px', pt: 1.5 }}>位置情報</Typography>
                                            </Grid>
                                            <Grid item xs={8.8} >
                                                <Typography sx={{ fontSize: '18px', pt: 1.5, pl: 1, pb: 1.5, border: 1, backgroundColor: '#f5f8fa' }}>
                                                    {props?.latitude}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={0.5} >
                                                {props?.mapLink ?
                                                    <IconButton onClick={openMap} >
                                                        <ExploreIcon sx={{ fontSize: '3rem', color: '#52B833' }} />
                                                    </IconButton>
                                                    :
                                                    <ExploreIcon sx={{ fontSize: '3rem', color: '#C0C0C0', }} />
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>
            </ThemeProvider >
        </React.Fragment >
    );
}